/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	if (!('xl9' in window)) {
	  window.xl9 = __webpack_require__(1);
	}
	


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var native = __webpack_require__(2);
	var util = __webpack_require__(4);
	var conf = __webpack_require__(3);
	var event = __webpack_require__(5);
	
	/**
	 * @todo 参数检查
	 * @todo 缓存
	 * @todo 调试模式
	 * @todo err返回错误描述不是很合理，万一要做判断就坑爹了
	 * @todo 修改track event示例和单元测试
	 * @todo 需要修改文档结构
	 */
	
	/**
	 * @callback dataCallback
	 * @param {(string|null)} err - 错误信息
	 * @param {(string|boolean)} [val] - 返回值
	 */
	
	/**
	 * @callback checkCallback
	 * @param {boolean} exist - 方法是否存在
	 */
	
	/** @callback handler */
	
	/**
	 * @callback loginHandler
	 * @param {string} userId - 用户id
	 * @param {string} jumpKey - jump key
	 */
	
	/**
	 * @callback changeSkinHandler
	 * @param {string} skinId - 皮肤id
	 * @param {string} isVip - 是否是会员
	 * @param {string} skinInfo - 皮肤信息
	 */
	
	var xl9 = {
	  api: {
	    /**
	     * 调用本地接口
	     * @function call
	     * @param {string} name - 方法名
	     * @param {...*} params - 方法需要的参数，可能是0个，1个或多个
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.call('ShowVipMiniPage', function (err) {
	     *   if (!err) {
	     *     console.log('show vip mini page');
	     *   }
	     * });
	     */
	    call: function () {
	      var args = Array.prototype.slice.call(arguments);
	      if (typeof args[args.length - 1] !== 'function') {
	        args.push(null);
	      }
	      native.callNativeFunction.apply(null, args);
	    },
	
	    /**
	     * 检查本地接口是否存在
	     * @function check
	     * @param {string} name - 方法名
	     * @param {checkCallback} callback - 回调函数
	     * @example
	     * xl9.api.check('GetUserID', function (exist) {
	     *   console.log('GetUserID is exist: ' + exist)
	     * });
	     */
	    check: function (name, callback) {
	      native.checkNativeFunction(name, function (exist) {
	        if (exist === 0) {
	          callback(true);
	        } else {
	          callback(false);
	        }
	      });
	    },
	
	    /**
	     * 监听本地事件
	     * @function attach
	     * @param {string} event - 事件类型
	     * @param {handler} callback - 事件处理器
	     * @returns {number} 事件标识
	     * @example
	     * xl9.api.attach('OnUserLogin', function (userId, jumpKey) {
	     *   console.log(userId + ', ' + jumpKey);
	     * });
	     */
	    attach: function (type, callback) {
	      if (type === 'OnUserLogin') {
	        return event.loginAttach(callback);
	      } else {
	        return native.attachNativeEvent.apply(null, arguments);
	      }
	    },
	
	    /**
	     * 解绑本地事件
	     * @function detach
	     * @param {string} type - 事件类型
	     * @param {number} eventId - 事件标识
	     * @example
	     * xl9.api.detach('OnUserLogin', 0);
	     */
	    detach: function (type, eventId) {
	      if (type === 'OnUserLogin') {
	        event.loginDetach(eventId);
	      } else {
	        native.detachNativeEvent.apply(null, arguments);
	      }
	    },
	
	    /**
	     * 获取用户ID
	     * @function getUserId
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getUserId(function (err, userId) {
	     *   if (!err) {
	     *     console.log(userId);
	     *   }
	     * });
	     */
	    getUserId: function (callback) {
	      native.callNativeFunction('GetUserID', callback);
	    },
	
	    /**
	     * 获取Jump Key
	     * @function getJumpKey
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getJumpKey(function (err, jumpKey) {
	     *   if (!err) {
	     *     console.log(jumpKey);
	     *   }
	     * });
	     */
	    getJumpKey: function (callback) {
	      native.callNativeFunction('GetJumpKey', callback);
	    },
	
	    /**
	     * 获取peerId
	     * @function getPeerId
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getPeerId(function (err, peerId) {
	     *   if (!err) {
	     *     console.log(peerId);
	     *   }
	     * });
	     */
	    getPeerId: function (callback) {
	      native.callNativeFunction('GetPeerID', callback);
	    },
	
	    /**
	     * 获取sessionID
	     * @function getSessionId
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getSessionId(function (err, sessionId) {
	     *   if (!err) {
	     *     console.log(sessionId);
	     *   }
	     * });
	     */
	    getSessionId: function (callback) {
	      native.callNativeFunction('GetSessionID', callback);
	    },
	
	    /**
	     * 获取skinId
	     * @function getSkinId
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getSkinId(function (err, skinId) {
	     *   if (!err) {
	     *     console.log(skinId);
	     *   }
	     * });
	     */
	    getSkinId: function (callback) {
	      native.callNativeFunction('GetSkinID', callback);
	    },
	
	    /**
	     * 获取skinInfo
	     * @function getSkinInfo
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getSkinInfo(function (err, skinInfo) {
	     *   if (!err) {
	     *     console.log(skinInfo);
	     *   }
	     * });
	     */
	    getSkinInfo: function (skinId, callback) {
	      native.callNativeFunction('GetSkinInfo', skinId, callback);
	    },
	
	    /**
	     * 弹出登入框
	     * @function showLoginDlg
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.showLoginDlg(function (err) {
	     *   if (!err) {
	     *     console.log('show login dialog');
	     *   }
	     * });
	     */
	    showLoginDlg: function (callback) {
	      native.callNativeFunction('ShowLoginDlg', callback);
	    },
	
	    /**
	     * 创建任务
	     * @function createTask
	     * @param {string} url - 下载链接
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.createTask('https://raw.githubusercontent.com/ElementUI/Resources/master/Element%20Components%20Documentation.zip', function (err) {
	     *   if (!err) {
	     *     console.log('task has been created');
	     *   }
	     * });
	     */
	    createTask: function (url, callback) {
	      native.callNativeFunction('CreateTask', url, function (err) {
	        if (err) {
	          window.open(url);
	        }
	        callback(null);
	      });
	    },
	
	    /**
	     * 埋点统计
	     * @function trackEvent
	     * @param {dataCallback} callback - 回调函数
	     * @param {object} opt - json
	     * @param {string} opt.key - key
	     * @param {string} opt.attr1 - attr1
	     * @param {string} opt.attr2 - attr2
	     * @param {string} opt.extData - extData
	     * @example
	     * xl9.api.trackEvent({
	     *   key: "right_area",
	     *   attr1: "home_page_show",
	     *   extData: "version=c"
	     * }, function (err) {
	     *   if (!err) {
	     *     console.log('track event');
	     *   }
	     * });
	     */
	    trackEvent: function (opt, callback) {
	      var extendOpt = util.deepExtend({ // 合并默认字段
	        key: '',
	        attr1: '',
	        attr2: '',
	        cost1: 0,
	        cost2: 0,
	        cost3: 0,
	        cost4: 0,
	        extData: ''
	      }, opt);
	
	      native.callNativeFunction('TrackEvent',
	        extendOpt.key,
	        extendOpt.attr1,
	        extendOpt.attr2,
	        extendOpt.cost1,
	        extendOpt.cost2,
	        extendOpt.cost3,
	        extendOpt.cost4,
	        extendOpt.extData,
	        callback);
	    },
	
	
	    /**
	     * 打开新标签页
	     * @function openNewTab
	     * @param {object} opt - json
	     * @param {string} opt.url - 新标签页链接
	     * @param {boolean} opt.selected - 是否被选中
	     * @param {string} opt.context - 标签页名称
	     * @param {boolean} opt.mainTab - 是否是主页
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.openNewTab({
	     *   url: 'lixian.xunlei.com/xl9/space.html?referfrom=v_pc_xl9_hytq_lx_lxkj',
	     *   selected: false,
	     *   context: 'offline_home',
	     *   mainTab: false
	     * }, function (err, tabId) {
	     *   if (!err) {
	     *     console.log(tabId);
	     *   }
	     * });
	     */
	    openNewTab: function (opt, callback) {
	      var extendOpt = util.deepExtend({
	        url: '',
	        selected: true,
	        context: null,
	        mainTab: false
	      }, opt);
	
	      native.callNativeFunction('OpenNewTab', extendOpt.url, extendOpt.selected, extendOpt.context, extendOpt.mainTab, callback);
	    },
	
	    /**
	     * 切换至客户端指定窗口
	     * @function selectTab
	     * @param {string} tabId - 标签页id
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.selectTab('4', function (err) {
	     *   if (!err) {
	     *     console.log('select tab');
	     *   }
	     * });
	     */
	    selectTab: function (tabId, callback) {
	      native.callNativeFunction('SelectTab', tabId, callback);
	    },
	
	    /**
	     * 判断客户端窗口是否存在
	     * @function isTabExist
	     * @param {string} tabId - 标签页id
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.isTabExist('4', function (err, exist) {
	     *   if (!err) {
	     *     console.log(exist);
	     *   }
	     * });
	     */
	    isTabExist: function (tabId, callback) {
	      native.callNativeFunction('IsTabExist', tabId, callback);
	    },
	
	    /**
	     * 根据context获得客户端窗口Id
	     * @function getTabIdByContext
	     * @param {string} context - 标签页名称
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getTabIdByContext('offline_home', function (err, tabId) {
	     *   if (!err) {
	     *     console.log(tabId);
	     *   }
	     * });
	     */
	    getTabIdByContext: function (context, callback) {
	      native.callNativeFunction('GetTabIDByContext', context, callback);
	    },
	
	    /**
	     * 安装后是否第一次打开迅雷9
	     * @function isMainPageFirstShow
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.isMainPageFirstShow(function (err, first) {
	     *   if (!err) {
	     *     console.log(first);
	     *   }
	     * });
	     */
	    isMainPageFirstShow: function (callback) {
	      native.callNativeFunction('IsMainPageFirstShow', callback);
	    },
	
	    /**
	     * 获得迅雷客户端版本号
	     * @function getThunderVersion
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getThunderVersion(function (err, version) {
	     *   if (!err) {
	     *     console.log(version);
	     *   }
	     * });
	     */
	    getThunderVersion: function (callback) {
	      native.callNativeFunction('GetThunderVersion', callback);
	    },
	
	    /**
	     * 写迅雷9配置文件
	     * @function setConfigValue
	     * @param {object} opt - json
	     * @param {string} opt.section - section
	     * @param {string} opt.key - key
	     * @param {string} opt.value - value
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.setConfigValue({
	     *   section: 'section',
	     *   key: 'key',
	     *   value: 'value'
	     * }, function (err) {
	     *   if (!err) {
	     *     console.log('set config value');
	     *   }
	     * });
	     */
	    setConfigValue: function (opt, callback) {
	      native.callNativeFunction('SetConfigValue', opt.section, opt.key, opt.value, callback);
	    },
	
	    /**
	     * 读迅雷9配置文件
	     * @function getConfigValue
	     * @param {object} opt - json
	     * @param {string} opt.section - section
	     * @param {string} opt.key - key
	     * @param {string} opt.defaultValue - 默认值
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.getConfigValue({
	     *   section: 'section',
	     *   key: 'key',
	     *   defaultValue: 'value'
	     * }, function (err, value) {
	     *   if (!err) {
	     *     console.log(value);
	     *   }
	     * });
	     */
	    getConfigValue: function (opt, callback) {
	      native.callNativeFunction('GetConfigValue', opt.section, opt.key, opt.defaultValue, callback);
	    },
	
	    /**
	     * 用户登出
	     * @function logout
	     * @param {dataCallback} callback - 回调函数
	     * @example
	     * xl9.api.logout(function (err) {
	     *   if (!err) {
	     *     console.log('logout');
	     *   }
	     * });
	     */
	    logout: function (callback) {
	      native.callNativeFunction('Logout', callback);
	    },
	
	    /**
	     * 用户登录事件
	     * @function onUserLogin
	     * @param {loginHandler} callback - 事件处理器
	     * @returns {number} 事件标识
	     * @example
	     * xl9.api.onUserLogin(function (userId, jumpKey) {
	     *   console.log('login emit');
	     * });
	     */
	    onUserLogin: function (callback) {
	      return event.loginAttach(callback);
	    },
	
	    /**
	     * 用户登出事件
	     * @function onUserLogout
	     * @param {handler} callback - 事件处理器
	     * @returns {number} 事件标识
	     * @example
	     * xl9.api.onUserLogout(function () {
	     *   console.log('logout emit');
	     * });
	     */
	    onUserLogout: function (callback) {
	      return native.attachNativeEvent('OnUserLogout', callback);
	    },
	
	    /**
	     * 用户换肤事件
	     * @function onChangeSkin
	     * @param {changeSkinHandler} callback - 事件处理器
	     * @returns {number} 事件标识
	     * @example
	     * xl9.api.onChangeSkin(function (skinId, isVip, skinInfo) {
	     *   console.log('change skin emit');
	     * });
	     */
	    onChangeSkin: function (callback) {
	      return native.attachNativeEvent('OnChangeSkin', callback);
	    }
	  },
	
	  /**
	   * 配置自动进行Jump key请求
	   * @function autoJump
	   * @param {boolean} auto - 是否自动进行Jump key请求
	   * @example
	   * xl9.autoJump(true);
	   */
	  autoJump: function (auto) {
	    var that = this;
	
	    conf.autoJump = auto;
	
	    // 自动登录
	    this.api.check('GetUserInfo', function (exist) {
	      if (!exist && conf.autoJump) {
	        that.api.getUserId(function (err, userId) { // 获取用户 ID
	          if (!err && userId > 0) {
	            that.api.getJumpKey(function (err, jumpKey) { // 获取 Jump Key
	              if (!err) {
	                util.jsonp({
	                  url: conf.jumpUrl,
	                  callback: 'callback',
	                  data: {
	                    u1: conf.jsonCallbackUrl + '?_=' + new Date().valueOf(),
	                    jump_key: jumpKey
	                  }
	                });
	              }
	            });
	          }
	        });
	      }
	    });
	  },
	
	  /**
	   * 是否在迅雷客户端
	   * @function isThunder
	   * @returns {boolean} 是否在迅雷客户端
	   * @example
	   * if (xl9.isThunder()) {
	   *   console.log('is thunder');
	   * }
	   */
	  isThunder: native.isThunder,
	
	  /**
	   * 通用登录
	   * @function login
	   * @param {dataCallback} callback - 回调函数
	   * @example
	   * xl9.login(function (err, userId) {
	   *   if (!err) {
	   *     console.log(userId);
	   *   }
	   * });
	   */
	  login: function (callback) {
	    var that = this;
	
	    if (!conf.autoJump) {
	      return;
	    }
	
	    that.api.getUserId(function (err, userId) {
	      if (err) { // 获取user id出错
	        callback(err);
	      } else {
	        if (userId === '0') { // 未登录
	          event.loginAttach(function (userId) {
	            callback(null, userId);
	          }, true);
	
	          that.api.showLoginDlg(function (err) {
	            if (err) {
	              callback(err);
	            }
	          });
	        } else { // 已登录
	          callback(null, userId);
	        }
	      }
	    });
	  }
	};
	
	module.exports = xl9;
	


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var conf = __webpack_require__(3);
	// var util = require('./util')
	
	var callNativeFunction; // 调用本地接口
	var checkNativeFunction; // 检查本地接口是否存在
	var attachNativeEvent; // 监听本地事件
	var detachNativeEvent; // 注销本地事件
	
	var isThunder = false;
	
	if (window.native && window.native.CallNativeFunction) { // Chrome内核
	  callNativeFunction = window.native.CallNativeFunction;
	  checkNativeFunction = window.native.CheckNativeFunction;
	  attachNativeEvent = window.native.AttachNativeEvent;
	  detachNativeEvent = window.native.DetachNativeEvent;
	}
	// else if ('CallNativeFunction' in window.external) { // IE内核
	//   callNativeFunction = function () {
	//     util.apply('window.external.CallNativeFunction', arguments);
	//   };
	
	//   checkNativeFunction = function () {
	//     util.apply('window.external.CheckNativeFunction', arguments);
	//   };
	
	//   attachNativeEvent = function () {
	//     util.apply('window.external.AttachNativeEvent', arguments);
	//   };
	
	//   detachNativeEvent = function () {
	//     util.apply('window.external.DetachNativeEvent', arguments);
	//   };
	// }
	else if (window.external && window.external.GetUserID) { // IE内核同步API
	  callNativeFunction = function () {
	    var args = Array.prototype.slice.call(arguments); // 参数列表
	    var name = args.shift(); // 方法名
	    var callback = args.pop(); // 回调函数
	    var cmd = 'window.external.' + name + '('; // 执行语句
	    var params = [];
	    var val; // 返回值
	
	    // 拼接执行的API语句
	    if (args.length > 0) {
	      for (var i = 0; i < args.length; i++) {
	        params.push('args[' + i + ']');
	      }
	      cmd += params.join(',');
	    }
	    cmd += ')';
	
	    try {
	      val = eval(cmd);
	      callback(conf.NFERRORCODE_SUCCESS, val);
	    } catch (e) {
	      callback(conf.NFERRORCODE_FUNCTIONNOTEXIST);
	    }
	  }
	
	  checkNativeFunction = function () {
	    var args = Array.prototype.slice.call(arguments); // 参数列表
	    var name = args.shift(); // 方法名
	    var callback = args.pop(); // 回调函数
	    if (window.external[name]) {
	      callback(conf.NFERRORCODE_SUCCESS);
	    } else {
	      callback(conf.NFERRORCODE_FUNCTIONNOTEXIST);
	    }
	  };
	
	  attachNativeEvent = function () {
	    return window.external.AttachEvent(arguments[0], arguments[1]);
	  };
	
	  detachNativeEvent = function () {
	    return window.external.DetachEvent(arguments[0], arguments[1]);
	  };
	} else { // 非迅雷9环境
	  callNativeFunction = function () {
	    var args = Array.prototype.slice.call(arguments);
	    var callback = args.pop();
	    callback(conf.NFERRORCODE_NOTINXL9);
	  };
	
	  checkNativeFunction = attachNativeEvent = detachNativeEvent = function () { };
	}
	
	var native = {
	  callNativeFunction: function () {
	    var args = Array.prototype.slice.call(arguments);
	    var callback = args.pop();
	    callNativeFunction.apply(null, args.concat(function (err, val) {
	      switch (err) {
	        case conf.NFERRORCODE_SUCCESS:
	          typeof callback === 'function' && callback(null, val);
	          break;
	        case conf.NFERRORCODE_FUNCTIONNOTEXIST:
	          typeof callback === 'function' && callback('function not exist');
	          break;
	        case conf.NFERRORCODE_PARAMETERERROR:
	          typeof callback === 'function' && callback('parameter error');
	          break;
	        case conf.NFERRORCODE_NOTINXL9:
	          typeof callback === 'function' && callback('not in xl9');
	          break;
	      }
	    }));
	  },
	
	  checkNativeFunction: checkNativeFunction,
	
	  attachNativeEvent: attachNativeEvent,
	
	  detachNativeEvent: detachNativeEvent,
	
	  isThunder: function () {
	    return isThunder;
	  }
	};
	
	// 判断是否在迅雷客户端中
	native.callNativeFunction('GetThunderVersion', function (err) {
	  if (!err) {
	    isThunder = true;
	  }
	});
	
	module.exports = native
	


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	module.exports = {
	  jumpUrl: '//jump.xunlei.com/jump/', // jump登录接口
	  jsonCallbackUrl: 'https://in-xl9-ssl.xunlei.com/index.php/user/jumpkey', // 迅雷9登录接口
	  autoJump: false, // 自动请求jump登录接口
	  NFERRORCODE_SUCCESS: 0, // 本地接口存在
	  NFERRORCODE_FUNCTIONNOTEXIST: 1, // 本地接口不存在
	  NFERRORCODE_PARAMETERERROR: 2, // 参数错误
	  NFERRORCODE_NOTINXL9: 3 // 非迅雷9环境
	};
	


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var conf = __webpack_require__(3)
	
	module.exports = {
	  /*
	   * 对象拓展
	   * @param {Object} [out] - 拓展初始对象
	   * @returns {Object} 拓展后对象
	   */
	  deepExtend: function (out) {
	    out = out || {};
	
	    for (var i = 1; i < arguments.length; i++) {
	      var obj = arguments[i];
	
	      if (!obj)
	        continue;
	
	      for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          if (typeof obj[key] === 'object' && obj[key] !== null)
	            out[key] = this.deepExtend(out[key], obj[key]);
	          else
	            out[key] = obj[key];
	        }
	      }
	    }
	
	    return out;
	  },
	
	  /*
	   * 格式化参数
	   * @param {Object} data - 格式化对象
	   * @returns {string} 格式化后字符串
	   */
	  formatParams: function (data) {
	    var arr = [];
	    for (var name in data) {
	      if (data.hasOwnProperty(name)) {
	        arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
	      }
	    }
	    return arr.join('&');
	  },
	
	  /**
	   * 发送 jsonp 请求
	   * @function jsonp
	   * @param {object} options - 请求选项
	   * @param {string} options.url - 请求url
	   * @param {string} options.callback - 回调方法名
	   * @param {object} options.data - 请求数据
	   * @param {function} options.success - 成功回调
	   * @param {function} options.fail - 失败回调
	   */
	  jsonp: function (options) {
	    options = options || {};
	
	    if (!options.url || !options.callback) {
	      throw new Error('参数不合法');
	    }
	
	    // 创建 script 标签并加入到页面中
	    var oHead = document.getElementsByTagName('head')[0];
	    var params = '';
	    if (options.data) {
	      options.data.callback = options.callback;
	      params += this.formatParams(options.data);
	    } else {
	      params += 'callback=' + options.callback;
	    }
	    var oS = document.createElement('script');
	    oHead.appendChild(oS);
	
	    // 创建jsonp回调函数
	    window[options.callback] = function (json) {
	      oHead.removeChild(oS);
	      clearTimeout(oS.timer);
	      window[options.callback] = null;
	      options.success && options.success(json);
	    };
	
	    // 发送请求
	    oS.src = options.url + '?' + params;
	
	    // 超时处理
	    if (options.time) {
	      oS.timer = setTimeout(function () {
	        window[options.callback] = null;
	        oHead.removeChild(oS);
	        options.fail && options.fail({ message: "超时" });
	      }, options.time);
	    }
	  },
	
	  /**
	   * @func setCookie
	   * @desc 设置cookie字段
	   * @param {string} domain - cookie域名
	   * @param {string} key - cookie参数
	   * @param {string} value - cookie值
	   * @param {number} hour - 过期小时数
	   */
	  setCookie: function (domain, key, value, hour) {
	    if (hour) {
	      var i = new Date((new Date()).getTime() + hour * 36e5);
	      document.cookie = key + "=" + escape(value) + ";path=/;domain=" + domain + ";expires=" + i.toGMTString();
	    } else {
	      document.cookie = key + "=" + escape(value) + ";path=/;domain=" + domain;
	    }
	  },
	
	  /**
	   * @func getCookie
	   * @desc 获取cookie字段
	   * @param {string} name - 字段名 
	   * @returns {(string|object)} 返回字段值或整个cookie对象
	   */
	  getCookie: function (name) {
	    var cookie = {};
	    var cookieSplit = document.cookie.split('; ');
	    var keyValue;
	
	    for (var i = 0; i < cookieSplit.length; i++) {
	      keyValue = cookieSplit[i].split('=');
	      cookie[keyValue[0]] = keyValue[1];
	    }
	
	    return name ? cookie[name] : cookie;
	  },
	
	  /**
	   * 用户登出时清除cookie
	   * @method clearCookie
	   */
	  clearCookie: function () {
	    document.cookie = 'userid=0;domain=xunlei.com;path=/;expires=' + new Date(0).toUTCString();
	    document.cookie = 'sessionid=0;domain=xunlei.com;path=/;expires=' + new Date(0).toUTCString();
	  },
	
	  /**
	   * 实现类 Function.prototype.apply 方法
	   * @function apply
	   */
	  apply: function (fcn, args) {
	    var cmd = fcn + '('; // 执行语句
	    var params = []; // 参数列表
	    var val; // 返回值
	
	    for (var i = 0; i < args.length; i++) {
	      params.push('args[' + i + ']');
	    }
	
	    cmd += params.join(',');
	    cmd += ')';
	
	    return eval(cmd);
	  }
	}
	


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	var native = __webpack_require__(2); // 本地接口
	var util = __webpack_require__(4); // 工具
	var conf = __webpack_require__(3);
	
	var eventId = 0; // 事件id，自增
	
	var event = {
	  loginHandlers: [], // 登录回调队列
	
	  loginAttach: function (callback, once) {
	    this.loginHandlers.push({
	      id: eventId,
	      callback: callback,
	      once: once
	    });
	    return eventId++;
	  },
	
	  loginDetach: function (eventId) {
	    for (var i = 0; i < this.loginHandlers.length; i++) {
	      if (eventId === this.loginHandlers[i].id) {
	        this.loginHandlers.splice(i, 1);
	      }
	    }
	  }
	};
	
	// 执行回调队列
	function execHandlers(event, userId, jumpKey) {
	  for (var i = 0; i < event.loginHandlers.length; i++) {
	    var callback = event.loginHandlers[i].callback;
	    typeof callback === 'function' && callback(userId, jumpKey);
	    if (event.loginHandlers[i].once) {
	      event.loginDetach(event.loginHandlers[i].id);
	    }
	  }
	}
	
	// 客户端登录事件
	// GetUserInfo方法存在时，使用客户端session，反之，使用长session
	native.attachNativeEvent('OnUserLogin', function (userId, jumpKey) {
	  native.checkNativeFunction('GetUserInfo', function (exist) {
	    if (exist === conf.NFERRORCODE_SUCCESS) {
	      execHandlers(event, userId);
	    } else {
	      if (conf.autoJump) {
	        util.jsonp({
	          url: conf.jumpUrl,
	          callback: 'callback',
	          data: {
	            u1: conf.jsonCallbackUrl + '?_=' + new Date().valueOf(),
	            jump_key: jumpKey
	          },
	          success: function () {
	            execHandlers(event, userId);
	          }
	        });
	      } else {
	        execHandlers(event, userId, jumpKey);
	      }
	    }
	  });
	});
	
	module.exports = event;
	


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// xl9.js